var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleSetLanguage}},[_c('img',{staticClass:"img_lang",attrs:{"src":require("../../assets/images/language.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }